"use client";

import { useEffect, useState } from "react";

export function useClientMediaQuery(query: string, defaultState = false) {
  const [matches, setMatches] = useState(defaultState);

  useEffect(() => {
    const mediaQueryList = window.matchMedia(query);
    const listener = () => setMatches(mediaQueryList.matches);

    setMatches(mediaQueryList.matches);
    mediaQueryList.addEventListener("change", listener);

    return () => mediaQueryList.removeEventListener("change", listener);
  }, [query]);

  return matches;
}
